interface PageTitleProps {
  label: string;
  description?: string;
  className?: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  label,
  description,
  className = "",
}) => {
  const renderDescription = () => {
    if (!description) return null;

    // \n 기준으로 줄바꿈
    return description.split("\n").map((line, i) => (
      <span key={i}>
        {line}
        {i < description.split("\n").length - 1 && <br />}
      </span>
    ));
  };

  return (
    <div className={` ${className}`}>
      <h2 className="semibold-text-20 text-md-18 text-sm-16 text-[#0075FF]">
        {label}
      </h2>
      {description && (
        <p className="bold-text-36 text-md-24 text-sm-20  text-black-100 mt-6 md:mt-8 lg:mt-12">
          {renderDescription()}
        </p>
      )}
    </div>
  );
};
